module.exports = __webpack_public_path__ + "static/img/setting.7de5163.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/setting.png
// module id = 6owm
// module chunks = 24